// Practice area detailed information
export const practiceAreaDetails = {
  en: {
    criminal: {
      title: 'Criminal Law Matters',
      icon: 'Scale',
      shortDesc: 'FIRs, Regular Bail, Anticipatory Bail, Trials',
      description: 'Comprehensive legal representation in all criminal matters with experienced handling of cases in district and high courts.',
      services: [
        'Filing and defending FIRs (First Information Reports)',
        'Regular Bail applications in all types of criminal cases',
        'Anticipatory Bail under Section 438 CrPC',
        'Criminal trial defense and prosecution',
        'Quashing petitions under Section 482 CrPC',
        'Appeals in criminal matters',
        'Legal advice on criminal proceedings'
      ],
      howWeHelp: 'Our firm provides strong legal defense with thorough case analysis, strategic planning, and aggressive representation to protect your rights and achieve the best possible outcome.'
    },
    civil: {
      title: 'Civil Litigation',
      icon: 'FileText',
      shortDesc: 'Civil disputes, Recovery cases, Injunctions',
      description: 'Expert handling of civil disputes with focus on achieving favorable outcomes through negotiation or litigation.',
      services: [
        'Civil suit filing and defense',
        'Money recovery and debt collection',
        'Temporary and permanent injunctions',
        'Declaratory suits',
        'Specific performance matters',
        'Contract disputes',
        'Appeals in civil matters'
      ],
      howWeHelp: 'We provide comprehensive civil litigation services with focus on protecting your interests, recovering dues, and resolving disputes efficiently through legal channels.'
    },
    family: {
      title: 'Family & Matrimonial Law',
      icon: 'Users',
      shortDesc: 'Divorce, Custody, Maintenance, Domestic Violence',
      description: 'Sensitive and professional handling of family matters with focus on amicable solutions and protection of rights.',
      services: [
        'Divorce proceedings (mutual consent and contested)',
        'Child custody and guardianship matters',
        'Maintenance claims under Section 125 CrPC',
        'Domestic violence cases under PWDVA',
        'Restitution of conjugal rights',
        'Nullity and judicial separation',
        'Adoption and guardianship proceedings'
      ],
      howWeHelp: 'We handle family matters with sensitivity and professionalism, focusing on protecting your rights while seeking amicable solutions wherever possible.'
    },
    property: {
      title: 'Property & Land Disputes',
      icon: 'Home',
      shortDesc: 'Land, Property, Possession, Partition',
      description: 'Specialized legal services for all property-related matters including title disputes, possession, and partition.',
      services: [
        'Property title verification and disputes',
        'Possession and eviction matters',
        'Partition suits',
        'Boundary disputes',
        'Property documentation',
        'Registration and mutation matters',
        'Adverse possession claims'
      ],
      howWeHelp: 'Our expertise in property law ensures thorough documentation review, clear title establishment, and effective resolution of property disputes through legal proceedings.'
    },
    banking: {
      title: 'Banking & Finance Law',
      icon: 'Landmark',
      shortDesc: 'Banking disputes, Loan recovery, Financial matters',
      description: 'Professional representation in banking and financial disputes including loan recovery and financial fraud cases.',
      services: [
        'Loan recovery matters',
        'Banking disputes and litigation',
        'Financial fraud cases',
        'Negotiable Instruments Act matters',
        'Banking transaction disputes',
        'Credit card and loan disputes',
        'Financial advisory on legal matters'
      ],
      howWeHelp: 'We provide strategic legal solutions for banking and financial disputes, ensuring your financial interests are protected through proper legal channels.'
    },
    cheque: {
      title: 'Cheque Bounce Cases',
      icon: 'Receipt',
      shortDesc: 'NI Act Section 138 matters, Legal notices',
      description: 'Specialized handling of dishonored cheque cases under Negotiable Instruments Act with high success rate.',
      services: [
        'Legal notice under Section 138 NI Act',
        'Filing criminal complaints for cheque bounce',
        'Defense in cheque bounce cases',
        'Settlement negotiations',
        'Appeals in NI Act matters',
        'Recovery of cheque amount',
        'Quashing of frivolous complaints'
      ],
      howWeHelp: 'Expert handling of cheque dishonor cases with prompt legal action, proper documentation, and aggressive pursuit of recovery or defense as per your requirement.'
    }
  },
  hi: {
    criminal: {
      title: 'आपराधिक कानून मामले',
      icon: 'Scale',
      shortDesc: 'एफआईआर, जमानत, मुकदमे',
      description: 'जिला और उच्च न्यायालयों में सभी आपराधिक मामलों में व्यापक कानूनी प्रतिनिधित्व।',
      services: [
        'एफआईआर दर्ज करना और बचाव',
        'सभी प्रकार के आपराधिक मामलों में नियमित जमानत',
        'सीआरपीसी की धारा 438 के तहत अग्रिम जमानत',
        'आपराधिक मुकदमे की रक्षा और अभियोजन',
        'सीआरपीसी की धारा 482 के तहत रद्दीकरण याचिका',
        'आपराधिक मामलों में अपील',
        'आपराधिक कार्यवाही पर कानूनी सलाह'
      ],
      howWeHelp: 'हमारी फर्म गहन मामले के विश्लेषण, रणनीतिक योजना और आक्रामक प्रतिनिधित्व के साथ मजबूत कानूनी बचाव प्रदान करती है।'
    },
    civil: {
      title: 'सिविल मुकदमेबाजी',
      icon: 'FileText',
      shortDesc: 'नागरिक विवाद, वसूली मामले',
      description: 'बातचीत या मुकदमेबाजी के माध्यम से अनुकूल परिणाम प्राप्त करने पर ध्यान केंद्रित करते हुए नागरिक विवादों का विशेषज्ञ संचालन।',
      services: [
        'नागरिक वाद दायर करना और बचाव',
        'धन वसूली और ऋण संग्रह',
        'अस्थायी और स्थायी निषेधाज्ञा',
        'घोषणात्मक मुकदमे',
        'विशिष्ट प्रदर्शन मामले',
        'अनुबंध विवाद',
        'नागरिक मामलों में अपील'
      ],
      howWeHelp: 'हम आपके हितों की रक्षा, बकाया वसूली और कानूनी चैनलों के माध्यम से विवादों को कुशलता से हल करने पर ध्यान केंद्रित करते हुए व्यापक नागरिक मुकदमेबाजी सेवाएं प्रदान करते हैं।'
    },
    family: {
      title: 'पारिवारिक और वैवाहिक कानून',
      icon: 'Users',
      shortDesc: 'तलाक, हिरासत, भरण-पोषण',
      description: 'सौहार्दपूर्ण समाधान और अधिकारों की सुरक्षा पर ध्यान केंद्रित करते हुए पारिवारिक मामलों का संवेदनशील और पेशेवर संचालन।',
      services: [
        'तलाक की कार्यवाही (आपसी सहमति और विवादित)',
        'बाल हिरासत और संरक्षकता मामले',
        'सीआरपीसी की धारा 125 के तहत भरण-पोषण दावे',
        'घरेलू हिंसा मामले',
        'वैवाहिक अधिकारों की बहाली',
        'शून्यता और न्यायिक अलगाव',
        'गोद लेने और संरक्षकता कार्यवाही'
      ],
      howWeHelp: 'हम संवेदनशीलता और व्यावसायिकता के साथ पारिवारिक मामलों को संभालते हैं, जहां भी संभव हो सौहार्दपूर्ण समाधान की तलाश करते हुए आपके अधिकारों की रक्षा करते हैं।'
    },
    property: {
      title: 'संपत्ति और भूमि विवाद',
      icon: 'Home',
      shortDesc: 'भूमि, संपत्ति, कब्जा, विभाजन',
      description: 'शीर्षक विवाद, कब्जा और विभाजन सहित सभी संपत्ति संबंधी मामलों के लिए विशेष कानूनी सेवाएं।',
      services: [
        'संपत्ति शीर्षक सत्यापन और विवाद',
        'कब्जा और बेदखली मामले',
        'विभाजन मुकदमे',
        'सीमा विवाद',
        'संपत्ति दस्तावेज़ीकरण',
        'पंजीकरण और म्यूटेशन मामले',
        'प्रतिकूल कब्जे के दावे'
      ],
      howWeHelp: 'संपत्ति कानून में हमारी विशेषज्ञता पूरी तरह से दस्तावेज़ समीक्षा, स्पष्ट शीर्षक स्थापना और कानूनी कार्यवाही के माध्यम से संपत्ति विवादों के प्रभावी समाधान सुनिश्चित करती है।'
    },
    banking: {
      title: 'बैंकिंग और वित्त कानून',
      icon: 'Landmark',
      shortDesc: 'बैंकिंग विवाद, ऋण वसूली',
      description: 'ऋण वसूली और वित्तीय धोखाधड़ी के मामलों सहित बैंकिंग और वित्तीय विवादों में पेशेवर प्रतिनिधित्व।',
      services: [
        'ऋण वसूली मामले',
        'बैंकिंग विवाद और मुकदमेबाजी',
        'वित्तीय धोखाधड़ी के मामले',
        'परक्राम्य लिखत अधिनियम मामले',
        'बैंकिंग लेनदेन विवाद',
        'क्रेडिट कार्ड और ऋण विवाद',
        'कानूनी मामलों पर वित्तीय सलाह'
      ],
      howWeHelp: 'हम बैंकिंग और वित्तीय विवादों के लिए रणनीतिक कानूनी समाधान प्रदान करते हैं, उचित कानूनी चैनलों के माध्यम से आपके वित्तीय हितों की रक्षा सुनिश्चित करते हैं।'
    },
    cheque: {
      title: 'चेक बाउंस मामले',
      icon: 'Receipt',
      shortDesc: 'एनआई अधिनियम धारा 138',
      description: 'उच्च सफलता दर के साथ परक्राम्य लिखत अधिनियम के तहत अनादरित चेक मामलों का विशेष संचालन।',
      services: [
        'एनआई अधिनियम की धारा 138 के तहत कानूनी नोटिस',
        'चेक बाउंस के लिए आपराधिक शिकायत दर्ज करना',
        'चेक बाउंस मामलों में बचाव',
        'निपटान वार्ता',
        'एनआई अधिनियम मामलों में अपील',
        'चेक राशि की वसूली',
        'तुच्छ शिकायतों को रद्द करना'
      ],
      howWeHelp: 'त्वरित कानूनी कार्रवाई, उचित दस्तावेज़ीकरण और आपकी आवश्यकता के अनुसार वसूली या बचाव के आक्रामक पीछा के साथ चेक अनादर मामलों का विशेषज्ञ संचालन।'
    }
  }
};
